<div>
  <div class="modal-header">
    <h2 class="page-title">Select Program</h2>
    <button type="button" class="close" (click)="close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="nav-white-box">
    <div class="container-fluid">
      <select class="text-box" (change)="filterProgram($event)" [(ngModel)]="selectedProgramId">
        <option *ngFor="let programItem of confirmText" [value]="programItem.recordId">{{programItem.value}}</option>
      </select>
    </div>
    <div>
      <mat-dialog-actions align="end">
        <button mat-button [mat-dialog-close]="true" cdkFocusInitial class="btn btn-ornge pull-right" style="height: 36px;width: 130px;margin-right: 15px;">OK</button>
        <button mat-button mat-dialog-close class="btn btn-gray" style="height: 36px;width: 130px;margin-right: 15px;">Cancel</button>
      </mat-dialog-actions>
    </div>
  </div>
</div>